module.exports = __webpack_public_path__ + "img/plus.1b6ea7ab.svg";